import React, {Component} from 'react';
import {createPortal} from 'react-dom';
import {View} from 'react-native';
import PropTypes from 'prop-types';
import colors from '../HelperClasses/AppColor';
import {ReactComponent as InfoSVGIcon} from './../assets/infoSVGIcon.svg';
import {ReactComponent as Uparrow} from './../assets/uparrow.svg';
import LocaleContext from '../Localization/LocaleContext';

export default class ToolTipViewBtn extends Component {
  static contextType = LocaleContext;
  t = (key, fallback) => this.context?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    this.state = {
      showView: false,
      tooltipPosition: null,
    };
  }
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    learnMoreUrl: PropTypes.string,
  };
  renderView = () => {
    const viewportWidth =
      typeof window !== 'undefined' ? window.innerWidth : 1024;
    const tooltipWidth = Math.min(360, Math.max(240, viewportWidth - 24));
    const tooltipLeft = this.state.tooltipPosition?.left ?? 12;
    const tooltip = (
      <div
        style={{
          position: 'fixed',
          top: this.state.tooltipPosition?.top ?? 0,
          left: Math.min(
            Math.max(12, tooltipLeft),
            Math.max(12, viewportWidth - tooltipWidth - 12),
          ),
          width: tooltipWidth,
          boxSizing: 'border-box',
          padding: 16,
          backgroundColor: colors.toolTipBGColor,
          borderRadius: 10,
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.25)',
          display: this.state.showView ? 'block' : 'none',
          zIndex: 2147483647,
          pointerEvents: this.props.learnMoreUrl ? 'auto' : 'none',
          onMouseEnter: () => {
            if (this.hideTimer) clearTimeout(this.hideTimer);
          },
          onMouseLeave: () => {
            this.hideTimer = setTimeout(() => {
              this.setState({showView: false});
            }, 150);
          },
        }}>
        <Uparrow
          style={{marginTop: -22, height: 16, width: 16, marginLeft: 5}}
        />
        <div>
          <div
            style={{
              color: '#ffffff',
              fontSize: 16,
              lineHeight: '22px',
              overflowWrap: 'anywhere',
            }}>
            {this.props.title}
          </div>

          <div
            style={{
              color: '#ffffff',
              fontSize: 14,
              lineHeight: '20px',
              marginTop: 10,
              overflowWrap: 'anywhere',
            }}>
            {this.props.description}
          </div>
          {this.props.learnMoreUrl && (
            <a
              href={this.props.learnMoreUrl}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-block',
                marginTop: 12,
                color: '#ffffff',
                fontSize: 14,
                fontWeight: 700,
                textDecoration: 'underline',
              }}>
              {this.t('common.learn_more', 'Learn more')}
            </a>
          )}
        </div>
      </div>
    );
    return typeof document !== 'undefined'
      ? createPortal(tooltip, document.body)
      : tooltip;
  };
  renderToolTipBtn = () => {
    return (
      <View
        style={{position: 'relative', zIndex: 999999999}}
        accessibilityRole="button"
        accessibilityLabel={this.t('common.show_information', 'Show information')}
        onClick={event => {
          const target = event?.currentTarget;
          const rect = target?.getBoundingClientRect?.();
          this.setState(previousState => ({
            showView: !previousState.showView,
            tooltipPosition: rect
              ? {top: rect.bottom + 8, left: rect.left - 13}
              : previousState.tooltipPosition,
          }));
        }}
        onMouseLeave={() => {
          this.hideTimer = setTimeout(() => {
            this.setState({showView: false});
          }, 150);
        }}
        onMouseEnter={event => {
          if (this.hideTimer) clearTimeout(this.hideTimer);
          const target = event?.currentTarget;
          const rect = target?.getBoundingClientRect?.();
          this.setState({
            showView: this.props.title == undefined ? false : true,
            tooltipPosition: rect
              ? {top: rect.bottom + 8, left: rect.left - 13}
              : null,
          });
        }}>
        <InfoSVGIcon
          style={{height: 20, width: 20, marginTop: 2, marginLeft: 10}}
        />
        {this.renderView()}
      </View>
    );
  };
  render() {
    return (
      <View style={{alignItems: 'center', marginTop: 2}}>
        {this.renderToolTipBtn()}
      </View>
    );
  }
}
